module.exports = __webpack_public_path__ + "static/media/arrow.b8d3df6d.svg";